import { resources } from "@constants/hardcoded-strings";
import { PolicyDecisionTypes } from "@enums/policy-decision-types";
import { VerificationTransactionDetailsSummary } from "@idw-types/data/verification-transaction-details";
import { isNullOrUndefined } from "@utils/object-util";
import classNames from "classnames";
import { useMemo } from "react";
import { CardContainer } from "../../../common/card-container/card-container";
import styles from "./verification-transaction-details-summary-container.less";

type VerificationTransactionDetailsSummaryContainerProps = {
    summary: VerificationTransactionDetailsSummary;
};

export const VerificationTransactionDetailsSummaryContainer = (props: VerificationTransactionDetailsSummaryContainerProps) => {
    const { summary } = props;    
    const idPrefix = 'verification-transaction-detail-summary';

    const policyDecisionTextColor = useMemo(() => {
        switch (summary?.policyDecision) {
            case PolicyDecisionTypes.APPROVED:
                return styles.green;
            case PolicyDecisionTypes.DENIED:
                return styles.red;
            default:
                return null;
        }
    }, [summary?.policyDecision]);

    return (
        <div className={styles.verificationTransactionDetailsSummaryContainer}>
            {!isNullOrUndefined(summary?.policyDecision) && (
                <CardContainer className={styles.summaryCard}>
                    <span id={`${idPrefix}-policy-decision`} className={classNames(styles.summaryData, policyDecisionTextColor)}>{summary.policyDecision}</span>
                    <span className={styles.summaryTitle}>{resources.pages.verificationTransactionDetails.cards.policyDecision.title}</span>
                </CardContainer>
            )}
            {!isNullOrUndefined(summary?.score) && (
                <CardContainer className={styles.summaryCard}>
                    <span id={`${idPrefix}-score`} className={styles.summaryData}>{summary.score}</span>
                    <span className={styles.summaryTitle}>{resources.pages.verificationTransactionDetails.cards.idwTrustScore.title}</span>
                </CardContainer>
            )}
            {!isNullOrUndefined(summary?.passCount) && (
                <CardContainer className={styles.summaryCard}>
                    <span id={`${idPrefix}-pass-count`} className={styles.summaryData}>{summary.passCount}</span>
                    <span className={styles.summaryTitle}>{resources.pages.verificationTransactionDetails.cards.passedAssertions.title}</span>
                </CardContainer>
            )}
            {!isNullOrUndefined(summary?.failCount) && (
                <CardContainer className={styles.summaryCard}>
                    <span id={`${idPrefix}-fail-count`} className={styles.summaryData}>{summary.failCount}</span>
                    <span className={styles.summaryTitle}>{resources.pages.verificationTransactionDetails.cards.failedAssertions.title}</span>
                </CardContainer>
            )}
            {!isNullOrUndefined(summary?.warnCount) && (
                <CardContainer className={styles.summaryCard}>
                    <span id={`${idPrefix}-warn-count`} className={styles.summaryData}>{summary.warnCount}</span>
                    <span className={styles.summaryTitle}>{resources.pages.verificationTransactionDetails.cards.warnAssertions.title}</span>
                </CardContainer>
            )}
            {!isNullOrUndefined(summary?.unverifiedCount) && (
                <CardContainer className={styles.summaryCard}>
                    <span id={`${idPrefix}-unverified-count`} className={styles.summaryData}>{summary.unverifiedCount}</span>
                    <span className={styles.summaryTitle}>{resources.pages.verificationTransactionDetails.cards.unverifiedAssertions.title}</span>
                </CardContainer>
            )}
        </div>
    );
};